<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`smartMatchProfiles.input`]>
      <v-row no-gutters>
        <v-col cols="6">
          <smart-match-profiles />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import SmartMatchProfiles from '@/components/SmartMatchProfiles';

export default {
  name: 'SmartMatchSettings',
  components: { AdminWrapper, SmartMatchProfiles },
  computed: {
    additionalModuleName: get('admin/additionalModules.SMART_MATCH_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@smart_match_module_enabled'),
    inputs() {
      return [
        {
          name: 'smartMatchProfiles',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'smart_match_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getProfiles: call('smartMatch/getProfiles'),
    async init() {
      await Promise.all([this.getProfiles(), this.getDataSources({ with_attributes_schema: true })]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
